<template>
    <v-dialog persistent v-model="pricePeriodDialog" max-width="700px">
        <v-card>
            <v-card-title>
                <h2 style="font-size: 20px !important;" class="headline-title"
                    v-if="provider.price_periods.length !== 0">
                    Attention : vos tarifs sont inchangés
                </h2>
                <h2 style="font-size: 20px !important;" class="headline-title" v-else>
                    Attention : vous n'avez pas saisi de tarifs
                </h2>
            </v-card-title>
            <v-card-text>
                <div v-if="provider.price_periods.length !== 0">
                    Vos tarifs n'ont pas été modifiés. Confirmez-vous qu'ils sont valides ?
                </div>
                <div v-else>
                    Confirmez-vous que vous n'avez pas de tarifs à communiquer ?
                </div>

                <v-spacer></v-spacer>

                <div class="d-flex justify-content-between mt-5">
                    <v-btn class="text-none" color="warning" outlined @click="scrollToPricePeriods"
                           v-if="provider.price_periods.length !== 0">
                        Modifier mes tarifs
                    </v-btn>
                    <v-btn class="text-none" color="warning" outlined @click="scrollToPricePeriods"
                           v-else>
                        Ajouter des tarifs
                    </v-btn>
                    <v-btn class="text-none" color="success" outlined @click="confirmPricePeriods">
                        Je confirme
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapState, mapMutations} from "vuex"

export default {
    name: "PricePeriodModal",
    methods: {
        ...mapMutations('web_form', ['setPricePeriodDialog', 'confirmPricePeriodDialog']),
        scrollToPricePeriods() {
            this.setPricePeriodDialog(false)

            this.$global.$emit('scroll-tab', 'price-period-tab')
        },
        confirmPricePeriods() {
            this.confirmPricePeriodDialog()

            this.$global.$emit('trigger-save')
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'pricePeriodDialog']),
    }
}
</script>

